import React, { useEffect, useRef } from "react";
import { cn } from "@/shared/utils/shadcn";

export function FocusWrapper({
  children,
  isFocused,
  className,
  focusedLabel,
}: {
  children: React.ReactNode;
  isFocused: boolean;
  className?: string;
  focusedLabel?: string;
}) {
  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (isFocused && wrapperRef.current) {
      wrapperRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, [isFocused]);

  return (
    <div className="flex flex-col" ref={wrapperRef}>
      {isFocused && (
        <div className="px-2 self-end mr-2 text-xs font-semibold text-purple-500 bg-purple-100 p-1 rounded-t-lg uppercase">
          {focusedLabel || "Currently in focus"}
        </div>
      )}
      <div
        className={cn(isFocused && "bg-purple-100 p-1 rounded-lg", className)}
      >
        {children}
      </div>
    </div>
  );
}
